import React from 'react';
import { Mode } from '../types';

interface ModeToggleProps {
  mode: Mode;
  setMode: (mode: Mode) => void;
}

const ModeToggle: React.FC<ModeToggleProps> = ({ mode, setMode }) => {
  return (
    <div className="flex items-center justify-center space-x-2 mt-4 mb-6">
      <span className={`text-sm font-medium ${mode === 'test' ? 'text-white' : 'text-gray-400'}`}>
        Test Mode
      </span>
      
      <button 
        onClick={() => setMode(mode === 'test' ? 'prod' : 'test')}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900 ${
          mode === 'prod' ? 'rainbow-gradient' : 'bg-gray-700'
        }`}
        aria-pressed={mode === 'prod'}
      >
        <span className="sr-only">
          {mode === 'prod' ? 'Switch to test mode' : 'Switch to production mode'}
        </span>
        <span 
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            mode === 'prod' ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
      
      <span className={`text-sm font-medium ${mode === 'prod' ? 'text-white' : 'text-gray-400'}`}>
        Production Mode
      </span>
    </div>
  );
};

export default ModeToggle;